var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../api/axios";
export const getModel = () => {
    return axiosPrivate.get(`/Account/GetModel?timestamp=${new Date().getTime()}`);
};
export const getSubscriptions = (onSuccess, onError) => {
    return axiosPrivate.get(`/Account/GetSubscriptions?timestamp=${new Date().getTime()}`).then(onSuccess).catch(onError);
};
export const getSubscriptionOrders = (subscriptionLinkId, onSuccess, onError) => {
    return axiosPrivate
        .get(`/Account/GetSubscriptionOrders?subscriptionLinkId=${subscriptionLinkId}`)
        .then(onSuccess)
        .catch(onError);
};
export const pauseSubscription = (id, orderIdsToCancel, onSuccess, onError) => {
    return axiosPrivate
        .post(`/Account/PauseSubscription`, { orderId: id, OrderIdsToCancel: orderIdsToCancel })
        .then(onSuccess)
        .catch(onError);
};
export const resumeSubscription = (id, onSuccess, onError) => {
    return axiosPrivate.post(`/Account/ResumeSubscription`, { orderId: id }).then(onSuccess).catch(onError);
};
export const cancelSubscription = (id, cancelReason, orderIdsToCancel, onSuccess, onError) => {
    return axiosPrivate
        .post(`/Account/CancelSubscription`, {
        OrderId: id,
        Value: cancelReason.Value,
        Note: cancelReason.Note,
        OrderIdsToCancel: orderIdsToCancel,
    })
        .then(onSuccess)
        .catch(onError);
};
/**
 * Used on the subscriptions page to select an order's pickup or delivery address.
 * @param newLocation
 * @param _balance -- Unused here; present only to match the shared function signature.
 * @param _giftCardId -- Unused here; present only to match the shared function signature.
 * @param onSuccess
 * @param onError
 * @returns
 */
export const updateSubscriptionDeliveryPickupLocation = (newLocation, _balance, // Unused here; present only to match the shared function signature.
_giftCardId, // Unused here; present only to match the shared function signature.
onSuccess, onError) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield axiosPrivate.post("/Account/OrderInfo/SubscriptionAddressLocation", newLocation);
        onSuccess(res.data); // Return res.data to match shared success function expected value.
    }
    catch (error) {
        onError(error);
    }
});
/**
 * Confirms the extra step for payment before updating the order
 * @param {*} newLocation
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const confirmThenUpdateOrderDelivery = (newLocation, onSuccess, onError) => {
    return axiosPrivate.post("/Account/OrderInfo/ConfirmThenUpdate", newLocation).then(onSuccess).catch(onError);
};
/**
 * ACCOUNT/DELIVERY ADDRESSES PAGE
 * @param {*} addressData
 * @param {*} onSuccess
 * @param {*} onError
 * @returns
 */
export const addUpdateAccountDeliveryAddress = (addressData, onSuccess, onError) => {
    return axiosPrivate.post("/Account/AddUpdateAccountDeliveryAddress", addressData).then(onSuccess).catch(onError);
};
export const updateCartCustomer = () => {
    return axiosPrivate.post("/Account/UpdateCartCustomer");
};
